import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaArrowUp } from "react-icons/fa";

const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const goToBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const listenToScroll = () => {
    let heightToHidden = 20;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHidden) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  return (
    <Wrapper>
      {isVisible && (
        <div className="top_btn" onClick={goToBtn}>
          <FaArrowUp className="top_btn--icon" />
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .top_btn {
    font-size: 22px;
    width: 50px;
    height: 50px;
    color: #fff;
    background-color: #383838;
    box-shadow: 0px 3px 10px -1px rgb(0 0 0 / 45%);
    border-radius: 50%;
    position: fixed;
    bottom: 1rem;
    right: 3.6rem;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &--icon {
      animation: gototop 1.2s linear infinite alternate-reverse;
    }

    @keyframes gototop {
      0% {
        transform: translateY(-0.5rem);
      }
      100% {
        transform: translateY(0.5rem);
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .top_btn {
      right: 4%;
      width: 40px;
      height: 40px;
      font-size: 18px;
    }
  }

  @media (min-width: 1200px) {
    .top_btn {
      right: 5%;
      width: 50px;
      height: 54px;
      font-size: 24px;
    }
  }
`;

export default GoToTop;
